import { StateCreator } from 'zustand';
import { CheckoutDeliveryOption, DeliveryOptionsFragment } from '@/gql';

export interface ShippingSlice {
  shippingRates?: DeliveryOptionsFragment;
  setShippingRates: (rates: DeliveryOptionsFragment) => void;

  shippingOption: CheckoutDeliveryOption;
  setShippingOption: (option: CheckoutDeliveryOption) => void;

  shippingRatesValidated: boolean;
  setShippingRatesValidated: (validated: boolean) => void;
}

export const createShippingSlice: StateCreator<ShippingSlice, [], [], ShippingSlice> = (set) => ({
  shippingRates: undefined,
  setShippingRates: (rates: any) => set({ shippingRates: rates }),

  shippingOption: 'fullStandardCost' as CheckoutDeliveryOption,
  setShippingOption: (option: CheckoutDeliveryOption) => set({ shippingOption: option }),

  shippingRatesValidated: false,
  setShippingRatesValidated: (validated: boolean) => set({ shippingRatesValidated: validated }),
});
